"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementType = void 0;
var AgreementType;
(function (AgreementType) {
    AgreementType["COMMODITY"] = "Commodity";
    AgreementType["EMOBILITY"] = "emobility";
    AgreementType["REIMBURSEMENT"] = "Reimbursement";
    AgreementType["LEASE"] = "Lease";
})(AgreementType = exports.AgreementType || (exports.AgreementType = {}));
